import {FC, useRef, useState} from "react";
import {
    Popper
} from "@mui/material";
import {
    CustomBadge,
    FilterIconButton,
} from "./act-info-styles";
import InfoIcon from '../info.svg';
import {getStoreUtils} from "../../../store/utils";
import { setToggleInfoAct } from "../../../ducks/montitoring";
import { getActInfoConditional } from "../../../selectors/monitoring";
import { useSelector } from "react-redux";


export const ActInfo: FC = () => {
    const anchorComp = useRef(null);
    const [openFilterMenu, setOpenFilterMenu] = useState(false);
    const {dispatch} = getStoreUtils();
    const isActInfoConditional = useSelector(getActInfoConditional)

    const handleFilterMenu = () => {
        setOpenFilterMenu((prevValue) => !prevValue)
        dispatch(setToggleInfoAct(!isActInfoConditional))
    }


    return (
      <FilterIconButton
        title={'Информация о контрагентах'}
        ref={anchorComp}
        size={"small"}
        isActive={openFilterMenu}
        onClick={handleFilterMenu}
        disableRipple
    >
        <CustomBadge isFilter variant="dot" invisible={true}>
            <img src={InfoIcon} alt="info" style={{ width: 24, height: 24, color: '#000' }} />
        </CustomBadge>
        <Popper
            anchorEl={anchorComp ? anchorComp.current : null}
            open={openFilterMenu}
            transition
            disablePortal
            sx={{top: 80, zIndex: 1100 }}
            placement={'bottom-start'}
        >
        </Popper>
    </FilterIconButton>
    )
}
